import { Component, OnInit, inject } from '@angular/core';
import { QuestionsService } from '../../services/questions.service';
import {
  InsightsDashboardStats,
  InsightsFilters,
  MonthlyAnsweredTrendItem,
  SpecialtyDistributionItem,
  TopExpertItem,
  TopQuestionItem,
  buildInsightsQueryParams,
  fillMonthlyTrendGaps,
} from '../../models/insights-dashboard.model';

@Component({
    selector: 'app-ask-ayen-insights-dashboard',
    templateUrl: './insights-dashboard.component.html',
    styleUrl: './insights-dashboard.component.scss',
    standalone: false
})
export class InsightsDashboardComponent implements OnInit {
  private questionsService = inject(QuestionsService);

  stats: InsightsDashboardStats | null = null;
  specialtyDistribution: SpecialtyDistributionItem[] = [];
  monthlyTrend: MonthlyAnsweredTrendItem[] = [];
  topQuestions: TopQuestionItem[] = [];
  topExperts: TopExpertItem[] = [];

  ngOnInit(): void {
    // /dashboard-summary/ analog: the stats endpoint takes no query params (unfiltered, all-time),
    // so it's fetched once and never re-fetched when filters change.
    this.questionsService.getInsightsDashboardStats().subscribe((response) => {
      this.stats = response.data;
    });
  }

  onFiltersChange(filters: InsightsFilters): void {
    this.loadInsights(filters);
  }

  private loadInsights(filters: InsightsFilters): void {
    const params = buildInsightsQueryParams(filters);

    this.questionsService.getInsightsDashboard(params).subscribe((response) => {
      const data = response.data;
      this.specialtyDistribution = data.specialty_distribution;
      this.monthlyTrend = fillMonthlyTrendGaps(data.monthly_answered_trend);
      this.topQuestions = data.top_questions;
      this.topExperts = data.top_experts;
    });
  }
}
